// A tap on a product card's colour dot swaps in that colour's photo, price and
// link. One listener on the document covers cards added later by filtering and
// load more; the flag keeps a second copy of this script from adding another.
if (!window.capraCardSwatches) {
  window.capraCardSwatches = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.capra-card__swatch');
    if (!swatch) return;

    const card = swatch.closest('.capra-card');
    const { src, srcset, url, price } = swatch.dataset;
    const image = card.querySelector('.capra-card__image');
    if (image && src) {
      image.srcset = srcset;
      image.src = src;
    }
    card.querySelector('.capra-card__link').href = url;
    card.querySelector('.capra-card__price').outerHTML = price;
    card.querySelectorAll('.capra-card__swatch').forEach((other) => {
      other.setAttribute('aria-pressed', String(other === swatch));
    });
  });
}
